import { Injectable } from '@angular/core';
import { LocalStorageCustomService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private static _tokenStorageKeyName: string = 'authToken';
  private static _tokenExpiryDateStorageKey: string = "tokenExpireDate"
  private static _refreshTokenStorageKeyName: string = 'refreshToken';
  private static _refreshTokenExpireDateStorageKeyName: string = "refreshTokenExpireDate"


  constructor(private cryptoStore: LocalStorageCustomService) {
  }

  getToken(): string | null {
    const getTokenValue = this.getValue(TokenService._tokenStorageKeyName);
    return getTokenValue;
  }

  getTokenExpiration(): string | null {
    const getTokenExpValue = this.getValue(TokenService._tokenExpiryDateStorageKey);
    return getTokenExpValue;
  }

  clearToken(): void {
    this.deleteValue(TokenService._tokenStorageKeyName);
    this.deleteValue(TokenService._tokenExpiryDateStorageKey);
    this.deleteValue(TokenService._refreshTokenStorageKeyName);
    this.deleteValue(TokenService._refreshTokenExpireDateStorageKeyName);
  }

  setToken(authToken: string, expireDate?: Date): void {
    this.setValue(TokenService._tokenStorageKeyName, authToken);
    if (expireDate)
      this.setValue(TokenService._tokenExpiryDateStorageKey, expireDate.toISOString());
  }

  //refresh token
  getRefreshToken(): string | null {
    return this.getValue(TokenService._refreshTokenStorageKeyName);
  }

  getRefreshTokenExpiration(): string | null {
    const getRefTokenExpValue = this.getValue(TokenService._refreshTokenExpireDateStorageKeyName);
    return getRefTokenExpValue;
  }

  clearRefreshToken(): void {
    this.deleteValue(TokenService._refreshTokenStorageKeyName);
  }

  setRefreshToken(refreshToken: string, expireDate?: Date): void {
    this.setValue(TokenService._refreshTokenStorageKeyName, refreshToken);
    if (expireDate)
      this.setValue(TokenService._refreshTokenExpireDateStorageKeyName, expireDate.toISOString())
  }

  private getValue(key: string): string | null {
    return this.cryptoStore.getSavedStateAsSecureStorage(key);
  }

  private setValue(key: string, value: string): void {
    this.cryptoStore.setSavedStateAsSecureStorage(value, key)
  }

  private deleteValue(key: string): void {
    this.cryptoStore.clearStorageByKey(key);
  }
}
